/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { pageTypes } from '@/constants/page';
import { useCategoryByModel } from '../../../api/getCategoryModels';
import { usePageType } from '../../../api/getPageType';
import { ShopByModelList } from '@/features/shopByModel';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';

export const CMSSmmy = () => {
  const router = useLegacyRouter();
  const { data: pageTypeData, isSuccess } = usePageType();

  const isPartsPage = pageTypeData?.catalogId === '0-0';

  const { data: categoryByModelData } = useCategoryByModel({
    enabled: Boolean(
      pageTypeData?.make &&
      !pageTypeData?.model &&
      pageTypeData?.pageType === pageTypes.CategoryGrouping &&
      isSuccess,
    ),
    seoUrl: router.asPath,
    acesOptions: {
      makeId: pageTypeData?.makeId ? Number(pageTypeData.makeId) : undefined,
      isPartsPage,
      categoryIdPath: pageTypeData?.categoryRepositoryIdPath,
    },
  });

  const devices = {
    desktop: true,
    tablet: true,
    mobile: true,
  };
  const shopByMMYList = categoryByModelData?.shopByMMYList ?? [];
  if (shopByMMYList.length) {
    return (
      <ShopByModelList
        data={{
          shopByMMYList,
          title: categoryByModelData?.title ?? '',
          canonicalPath: categoryByModelData?.canonicalPath,
          taxonomyPath: categoryByModelData?.taxonomyPath,
          pageType: categoryByModelData?.pageType,
          ...devices,
        }}
      />
    );
  }
  return null;
};
